import React from 'react';
import './index.css';
import { Steps, Badge ,WingBlank, WhiteSpace ,List } from 'antd-mobile';
import history from 'common/history';
import videoIcon from './img/icon_video.png';
import examIcon from './img/icon_exam.png';
import testIcon from './img/icon_test.png';
const Step = Steps.Step;
const Item = List.Item;
const Brief = Item.Brief;
class StepTitle extends React.Component{
  render(){
    const {data,index} =this.props;
    return(
        <div className="labroom-step-title">
          <div className="title-top">
            <div className="step-name">第{index+1}章</div>
          </div>
          <div className="title-bottom">{data.title}</div>
        </div>)
  }
}
class StepDes extends React.Component{
  push(sid,content){
    const {id} = this.props
    // console.log(this.props.match.params.id)
    if(content && content.type){
       if( content.type==='video'){
           history.push('/labroomvideo/courseid='+id+'&sid='+sid)
        }else if(content.type==='experi'){
          history.push('/labroomexper/courseid='+id+'&sid='+sid)
        }else if(content.type==='exam') {
          window.open(window.AppConfig.examUrl+'?exam-phone-callback&basicid='+content.basicid+'&subjectid='+sid+'&course_id='+id)
        }
    }else{
      console.log('content is null')
    }
  }

  render(){
    const {data, finish} = this.props;
    for (let dataItem of data) {
      for (let item of dataItem.childs) {
        let isLearnFinish = finish.find(value => item.id==value)
        if (isLearnFinish) item.isLearnFinish = true
      }
    }
    
    return(
      <List className="labroom-step-des">
        {
          data?
          data.map((item,index)=>{
              return(
                <div key={index}>
                   {
                    item.childs?
                     item.childs.map((s,i)=>{
                       let point;
                       if(s.isLearnFinish){
                        point = <span style={{borderRadius: '50%', border:'1px solid #57cbc6', backgroundColor: '#57cbc6',
                        position: 'absolute', marginLeft: '1px', width: '8px', height: '8px', zIndex: '2', top: '46%'}}></span>
                      } else if (!s.Duration){
                        point = <span style={{borderRadius: '50%', border:'1px solid #CCCCCC', backgroundColor: '#fff',
                        position: 'absolute', marginLeft: '1px', width: '8px', height: '8px', zIndex: '2', top: '46%'}}></span>
                      }
                      else {
                        point = <span style={{borderRadius: '50%', border:'1px solid #57cbc6', backgroundColor: '#fff',
                        position: 'absolute', marginLeft: '1px', width: '8px', height: '8px', zIndex: '2', top: '46%'}}></span>
                      }
                       return(
                         <div style={{display:"block", position: "relative"}}>
                           {/*// 判断是否学过此课程*/}
                           <div className="step-self">
                              {point}
                             {
                               i+1 == item.childs.length? null: <span style={{
                                 width: 1,
                                 height: '100%',
                                 backgroundColor: '#eeeeee',
                                 marginLeft: '4px',
                                 position: 'absolute',
                                 zIndex: 1,
                                 top: '50%'}}></span>
                             }
                           </div>
                           <div key={i}>
                              <Item onClick={()=>{this.push(s.id,s.content)}}
                                 thumb={<img src={s.content && s.content.type==='video'?videoIcon:(s.content && s.content.type==='exam'?examIcon:testIcon)} alt=""/>}>
                                <div className="work-list">
                                <div className="work-title">{s.title}</div>
                                </div>
                              </Item>
                           </div>
                         </div>
                         )
                     }):null
                   }
                </div>
                )

          }):null
        }

      </List>)
  }
}
class RoomCatalog extends React.Component{
  stepTag(data, finish){
     if(data){
       return data.map((s, i) =>
             <Step
                key={i}
                status={'process'}
                title={<StepTitle data={s} index={i}/>}
                description={<StepDes data={s.childs} finish={finish} id={this.props.id}/>}
                icon={ <Badge dot className="dot"></Badge>
                } />
         )

    }
  }
  render(){
    const {data,id, finish} = this.props;
    return (
      <div className="room-catalog">
          <WingBlank size="lg">
            <WhiteSpace />
            {/*<span style={{position: 'absolute', width: 1, backgroundColor: '#eeeeee',height: '100%',*/}
            {/*  top: 22, zIndex: '0'}}></span>*/}
            <Steps>
               { data&&data.size!=0
                ?
                this.stepTag(data.toJS(), finish.toJS() )
                :null
              }
            </Steps>
          </WingBlank >
      </div>
      )
  }
}
export default RoomCatalog;
